import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-grievance-total-count',
  templateUrl: './grievance-total-count.component.html',
  styleUrls: ['./grievance-total-count.component.scss'],
})
export class GrievanceTotalCountComponent  implements OnInit {
  @Input({required: true}) countData!: {
    value: string,
    count: number
  };
  constructor() { }
  
  ngOnInit() {}
  
}
